import React, { useEffect, useState } from "react";
import Header from '../../Header';
import "../../styles/theme.scss";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { Grid, Typography, Button } from "@mui/material";
import ContractTab from "./ContractTab";
import ContractDetailsFrom from "./ContractDetailsFrom";
import ContractDetailsTable from "./ContractDetailsTable";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { submitContract } from "../../action";
import CommonSnackbar from "../../reusableComponents/components/generics/CommonSnackbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // Add margin top here
  // marginTop: theme.spacing(10), // Adjust the spacing as needed
}));

const StyledLabel = styled(Typography)({
  fontSize: "2vw",
  fontWeight: "bold",
  color: "#000",
});

function ContractDetailsContent() {
  const SignInSuccess = useSelector((state) => state);
  const contractState = useSelector((state) => state);
  const contractStatus = contractState?.profileReducer?.contracts?.[0]?.state

  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const splittedid = id.split("=")[1];
  const [filter, setFilter] = useState(false);
  const [insureeData, setInsureeData] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [showSnakBar, setShowSnakBar] = useState(false);

  const goBack = () => {
    navigate(-1); // Navigate back one step in history
  };
  let mutation = SignInSuccess?.profileReducer?.mutations;
  useEffect(() => {
    if(snackbarMessage){
    if (mutation && mutation.length > 0 && mutation[0]?.status === 2) {
      setSnackbarSeverity('success');
      // setSnackbarMessage('Isuree Successfully add in to policyholder.');
      setSnackbarOpen(true);
      setShowSnakBar(true)
    } else if (mutation && mutation.length > 0 && mutation[0]?.status === 1) {
      setSnackbarSeverity('error');
      setSnackbarMessage(t('Failed to done any action in Contract.'));
      setSnackbarOpen(true);
    } else if (!mutation) {
      setSnackbarOpen(false);
    }
  }
  }, [mutation]);
  const handleSubmit = () => {
    dispatch(submitContract(splittedid))
    setSnackbarMessage(t("Contract Submitted Sucessfully"))
  }
  const handleSnackbarClose = async (event, reason) => {
    // window.location.reload();
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };
  return (
    <Grid >
      <Header
        children={
          <Content>
            <Grid container>
              <Grid container direction="column">
                <Typography
                  variant="body1"
                  onClick={() => goBack()}
                  style={{ cursor: "pointer" }}
                >
                  <ArrowBackIcon className="pr-2" />
                  {t("Back to Employee Declaration")}
                </Typography>
                <Grid
                  item
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <StyledLabel> {t("Declaration Details")}</StyledLabel>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    style={{ marginTop: ".5rem" }}
                    onClick={handleSubmit}
                    disabled={contractStatus == 4||contractStatus == 5 ? true : false}
                  //   fullWidth
                  >
                    {t("Submit Declaration")}
                  </Button>
                </Grid>
              </Grid>

              <ContractDetailsFrom
                policyHolderId={splittedid}
                setFilter={setFilter}
                filter={filter}
                showSnakBar={showSnakBar}
              />

              <ContractDetailsTable
                policyHolderId={splittedid}
                filter={filter}
                setInsureeData={setInsureeData}
              />
            </Grid>
          </Content>
        }
      />
      <CommonSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Grid>
  );
}

export default ContractDetailsContent;
